import { Observable } from './observable';

class GamePortalPagesStateService {
  readonly openBlockIndex = new Observable<number | undefined>(undefined);
  readonly openItemIndex = new Observable<string | undefined>(undefined); // Format: "blockIndex-itemIndex"

  clear = () => {
    this.openBlockIndex.set(undefined);
    this.openItemIndex.set(undefined);
  };

  setOpenBlockIndex = (index: number | undefined) => {
    this.openBlockIndex.set(index);
    // Close any open items when a block is closed
    if (index === undefined) {
      this.openItemIndex.set(undefined);
    }
  };

  setOpenItemIndex = (itemKey: string | undefined) =>
    this.openItemIndex.set(itemKey);
}

export const gamePortalPagesStateService = new GamePortalPagesStateService();

